<script lang="ts">
  import type { Snippet } from "svelte";

  let { question, children } = $props<{
    question: string;
    children: Snippet;
  }>();
</script>

<div class="mb-4">
  <h3 class="text-l font-semibold mb-3">{question}</h3>
  {@render children()}
</div>
